define('components/handlers/iframe-subscription',[
    'components/decorator',
    'jquery'
],function(
    decorator,
    $
){

    $.extend(companyInfo.handlers, {
        'iframe-subscription': function (e) {
            var GA_ClientId = $("#GA_ClientId");
            var GA_TrackingId = $("#GA_TrackingId");
            var GA_UserAgent = $("#GA_UserAgent");


            if(GA_ClientId){
                $(GA_ClientId).val(GTM.get('GA_ClientId'));
            }
            if(GA_TrackingId){
                $(GA_TrackingId).val(GTM.get('GA_TrackingId'));
            }
            if(GA_UserAgent){
                $(GA_UserAgent).val(GTM.get('GA_UserAgent'));
            }
        }

    });

});

